import React from "react";

const PersonalInformationForm = ({
  formData,
  setFormData,
  handleNext,
  handleBack,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    console.log(formData);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    console.log("Submitted data:", formData);
    sessionStorage.setItem("form", JSON.stringify(formData));
    handleNext();
  };

  return (
    <form onSubmit={handleSubmit} className="w-full mx-auto p-4  rounded-lg">
      <div className="space-y-4">
        {/* First, Middle, Last Name */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              First name
            </label>
            <input
              type="text"
              placeholder="Enter first name"
              name="first_name"
              value={formData?.first_name || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
              // required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Middle name
            </label>
            <input
              type="text"
              name="middle_name"
              placeholder="Enter middle name"
              value={formData?.middle_name || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
              // required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Last name
            </label>
            <input
              type="text"
              placeholder="Enter last name"
              name="last_name"
              value={formData?.last_name || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
        </div>

        {/* Home Address */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Home address
          </label>
          <input
            type="text"
            name="home_address"
            placeholder="Enter business address"
            value={formData?.home_address || ""}
            onChange={handleChange}
            className="mt-1 w-full p-2 border rounded"
          />
        </div>

        {/* Date of Birth, BVN, NIN */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Date of birth
            </label>
            <input
              type="text"
              placeholder="DD/MM/YYYY"
              name="date_of_birth"
              value={formData?.date_of_birth || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Bank verification number (BVN)
            </label>
            <input
              type="number"
              name="bvn"
              placeholder="XXX - XXXX - XXX"
              value={formData?.bvn || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              National identification number (NIN)
            </label>
            <input
              type="number"
              name="nin"
              placeholder="XXX - XXXX - XXX"
              value={formData?.nin || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
        </div>

        {/* Email & Phone Number */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <input
              type="email"
              placeholder="Enter email address"
              name="email"
              value={formData?.email || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Phone number
            </label>
            <div className="flex items-center border rounded p-2 mt-1">
              <input
                type="tel"
                placeholder="XXX - XXX - XXXX"
                name="phoneno"
                value={formData?.phoneno || ""}
                onChange={handleChange}
                className="flex-1 pl-2 outline-none"
              />
            </div>
          </div>
        </div>

        {/* Next Button */}
      </div>

      <div className="flex justify-center mt-6">
        <button
          type="button"
          onClick={handleBack}
          className="px-6 py-2 bg-gray-300 rounded"
        >
          Back
        </button>{" "}
        <button
          type="submit"
          className="ml-auto px-6 py-2 bg-blue-600 text-white rounded"
        >
          Next
        </button>
      </div>
    </form>
  );
};

export default PersonalInformationForm;
